import { render, staticRenderFns } from "./StudentClassrooms.vue?vue&type=template&id=4ba974aa&"
import script from "./StudentClassrooms.vue?vue&type=script&lang=js&"
export * from "./StudentClassrooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports